import { Box, MenuItem, SelectChangeEvent, TextField } from '@mui/material';
import { FormSection } from './FormSection';
import SweepSelect from '../../common/SweepSelect';
import { useWebhooksContext } from './WebhooksContext';
import { AuthenticationComponents } from './AuthenticationComponents';
import { LogoDevSelector } from '../../common/logo-dev-selector/LogoDevSelector';
import { LogoDevBrand } from '../../../apis/facades/useLogoDevApiFacade';
import { validateUrlRegex } from '../../../lib/validateUrlRegex';

export enum CustomIntegrationAuthenticationType {
  BASIC = 'BASIC',
  API_KEY = 'API_KEY',
  BEARER_TOKEN = 'BEARER_TOKEN',
  TOKEN_TOKEN = 'TOKEN_TOKEN',
  QUERY_PARAM_KEY = 'QUERY_PARAM_KEY',
}

const AuthenticationTypeLabels = [
  { type: CustomIntegrationAuthenticationType.BASIC, label: 'Basic (user name and password)' },
  { type: CustomIntegrationAuthenticationType.API_KEY, label: 'API key' },
  { type: CustomIntegrationAuthenticationType.QUERY_PARAM_KEY, label: 'Query param key' },
  { type: CustomIntegrationAuthenticationType.BEARER_TOKEN, label: 'Bearer token' },
  { type: CustomIntegrationAuthenticationType.TOKEN_TOKEN, label: 'Token' },
];

export const WebhookContent = () => {
  const { editWebhook, setEditWebhook } = useWebhooksContext();

  return (
    <Box pt={1}>
      <FormSection label="Integration name">
        <TextField
          sx={{ width: '100%' }}
          placeholder={'e.g. Acme'}
          value={editWebhook?.name}
          onChange={(event) => {
            const newValue = event?.target.value;
            setEditWebhook({ ...editWebhook, name: newValue });
          }}
        />
      </FormSection>
      <FormSection label="Integration logo (optional)">
        <LogoDevSelector
          onChange={(brand: LogoDevBrand | null) => {
            setEditWebhook({ ...editWebhook, logo: brand ?? undefined });
          }}
          brand={editWebhook?.logo}
          placeholder="Choose logo"
        />
      </FormSection>
      <FormSection label="Integration's URL">
        <TextField
          helperText={
            !!editWebhook?.baseUrl && !validateUrlRegex(editWebhook?.baseUrl ?? '')
              ? 'Please insert a valid URL address'
              : ''
          }
          error={!!editWebhook?.baseUrl && !validateUrlRegex(editWebhook?.baseUrl ?? '')}
          sx={{ width: '100%' }}
          placeholder={'e.g. www.acme.io'}
          value={editWebhook?.baseUrl}
          onChange={(event) => {
            const newValue = event?.target.value;
            setEditWebhook({ ...editWebhook, baseUrl: newValue });
          }}
        />
      </FormSection>
      <FormSection label="Authentication method">
        <SweepSelect
          FormControlProps={{
            sx: { width: 'fit-content' },
          }}
          SelectProps={{
            placeholder: 'Choose method',
            value: editWebhook?.authentication?.type,
            onChange: (event: SelectChangeEvent<unknown>) => {
              const val = event.target.value as CustomIntegrationAuthenticationType;
              setEditWebhook({
                ...editWebhook,
                authentication: { type: val, key: undefined, password: '' },
              });
            },
          }}
        >
          {AuthenticationTypeLabels.map((elem) => {
            return (
              <MenuItem key={elem.type} value={elem.type}>
                {elem.label}
              </MenuItem>
            );
          })}
        </SweepSelect>
      </FormSection>
      <AuthenticationComponents />
    </Box>
  );
};
